var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "third-upload cnt1200" },
    [
      _c(
        "page-header",
        {
          attrs: {
            title: "",
            paths: ["上传答题卡图片"],
            "use-region-back": false,
          },
        },
        [
          _c("p", { staticClass: "download", on: { click: _vm.downloadExe } }, [
            _vm._v(" 下载客户端 "),
            _c("img", {
              attrs: {
                src: require("../../../../../assets/images/download-icon.png"),
                width: "16px",
                alt: "下载客户端",
              },
            }),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.fileList.length === 0,
              expression: "fileList.length === 0",
            },
          ],
          staticClass: "upload-body",
        },
        [
          _c(
            "div",
            { staticClass: "upload-basic" },
            [
              _c("span", { staticClass: "span-label" }, [_vm._v("年级：")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "选择年级",
                    disabled: _vm.optionDisabled,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.loadSubjects()
                    },
                  },
                  model: {
                    value: _vm.upload.grade,
                    callback: function ($$v) {
                      _vm.$set(_vm.upload, "grade", $$v)
                    },
                    expression: "upload.grade",
                  },
                },
                _vm._l(_vm.gradeList, function (grade, index) {
                  return _c("el-option", {
                    key: "grade" + index,
                    attrs: { label: grade.gradeName, value: grade.gradeNum },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "span-label",
                  staticStyle: { "margin-left": "40px" },
                },
                [_vm._v("学科：")]
              ),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "选择科目",
                    disabled: _vm.optionDisabled,
                  },
                  model: {
                    value: _vm.upload.subjectCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.upload, "subjectCode", $$v)
                    },
                    expression: "upload.subjectCode",
                  },
                },
                _vm._l(_vm.subjectList, function (subject, index) {
                  return _c("el-option", {
                    key: "subject" + index,
                    attrs: {
                      label: subject.subjectName,
                      value: subject.subjectId,
                    },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "span-label",
                  staticStyle: { "margin-left": "40px" },
                },
                [_vm._v("阅卷方式：")]
              ),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "选择阅卷方式",
                    disabled: _vm.optionDisabled,
                  },
                  model: {
                    value: _vm.upload.isHen,
                    callback: function ($$v) {
                      _vm.$set(_vm.upload, "isHen", $$v)
                    },
                    expression: "upload.isHen",
                  },
                },
                _vm._l(_vm.hens, function (hen, index) {
                  return _c("el-option", {
                    key: "hen" + index,
                    attrs: { label: hen.name, value: hen.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "upload-basic",
              staticStyle: { "margin-top": "24px" },
            },
            [
              _c("span", { staticClass: "span-label" }, [_vm._v("张数：")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "选择张数",
                    disabled: _vm.optionDisabled,
                  },
                  on: { change: _vm.sheetChange },
                  model: {
                    value: _vm.upload.sheetCount,
                    callback: function ($$v) {
                      _vm.$set(_vm.upload, "sheetCount", $$v)
                    },
                    expression: "upload.sheetCount",
                  },
                },
                _vm._l(3, function (i) {
                  return _c("el-option", {
                    key: "sheetCount" + i,
                    attrs: { label: i + "张", value: i },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "span-label",
                  staticStyle: { "margin-left": "40px" },
                },
                [_vm._v("面数：")]
              ),
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.optionDisabled },
                  model: {
                    value: _vm.upload.sideCount,
                    callback: function ($$v) {
                      _vm.$set(_vm.upload, "sideCount", $$v)
                    },
                    expression: "upload.sideCount",
                  },
                },
                _vm._l(_vm.sides, function (side) {
                  return _c(
                    "el-radio",
                    { key: "side-" + side.value, attrs: { label: side.value } },
                    [_vm._v(_vm._s(side.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._m(0),
          _c("div", { staticClass: "upload-images" }, [
            _vm.fileList.length > 0
              ? _c(
                  "div",
                  { staticClass: "upload-image" },
                  [
                    _c("el-image", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        src: _vm.upload.ossUrl,
                        "preview-src-list": _vm.fileList,
                        fit: "scale-down",
                      },
                    }),
                    _c("span", {
                      staticClass: "el-icon-circle-close",
                      on: {
                        click: function ($event) {
                          _vm.fileList = []
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "upload-ways" }, [
            _vm.isGrayscaleUser
              ? _c("div", { staticClass: "upload-way upload-client" }, [
                  _c(
                    "div",
                    {
                      staticClass: "upload-logo",
                      on: { click: _vm.startScanAction },
                    },
                    [_vm._m(1)]
                  ),
                  _c(
                    "div",
                    { staticClass: "upload-desc" },
                    [
                      _c("span", { staticStyle: { color: "#333" } }, [
                        _vm._v("客户端："),
                      ]),
                      _vm.connectStatus > 0
                        ? _c("span", { staticStyle: { color: "#2877FF" } }, [
                            _vm._v("已连接"),
                          ])
                        : [
                            _c("span", { staticStyle: { color: "#FF4C3B" } }, [
                              _vm._v("未连接"),
                            ]),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "right",
                                  width: "320",
                                  trigger: "click",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "line-height": "1.5",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("未连接，请按以下步骤检查：")]
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("1、是否安装扫描仪驱动；"),
                                    ]),
                                    _c("p", [_vm._v("2、usb是否连接正常")]),
                                  ]
                                ),
                                _c("span", {
                                  staticClass: "el-icon-question",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ],
                      _c("i", {
                        staticClass: "upload-client-sitting",
                        attrs: { title: "设置扫描参数" },
                        on: { click: _vm.openScanCoinfg },
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "upload-way" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticStyle: { color: "#2877ff" },
                    attrs: {
                      type: "info",
                      accept: ".png, .jpg, .jpeg",
                      multiple: "",
                      action: "",
                      "on-change": _vm.handleChangeAction,
                      "file-list": _vm.fileList,
                      "show-file-list": false,
                      "auto-upload": false,
                    },
                  },
                  [
                    _c("div", { staticClass: "upload-logo" }, [
                      _c("div", { staticClass: "inner-logo" }, [
                        _c("img", {
                          attrs: {
                            alt: "添加图片",
                            src: require("../../assets/images/upload-img.png"),
                          },
                        }),
                        _c("p", [_vm._v("上传图片")]),
                      ]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "upload-desc" }, [
                  _vm._v("支持 jpg、png格式，小于5M"),
                ]),
                _vm.uploadDisabled
                  ? _c("div", {
                      staticClass: "upload-cover",
                      on: { click: _vm.startScanAction },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "upload-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "ok-btn",
                  staticStyle: { float: "left" },
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.createCard()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.fileList.length > 0,
              expression: "fileList.length > 0",
            },
          ],
          staticClass: "upload-files-result upload-body",
        },
        [
          _c("div", { staticClass: "upload-basic" }, [
            _c(
              "span",
              { staticClass: "span-label", staticStyle: { width: "85px" } },
              [_vm._v("答题卡规格：")]
            ),
            _c("span", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(
                _vm._s(_vm.upload.sheetCount) +
                  "张" +
                  _vm._s(_vm.upload.sideCount) +
                  "面"
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "upload-basic-item",
              staticStyle: { "margin-top": "20px" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "span-label",
                  staticStyle: { width: "85px", "vertical-align": "top" },
                },
                [_vm._v("答题卡预览：")]
              ),
              _c(
                "div",
                { staticClass: "upload-image-list" },
                [
                  _c(
                    "draggable",
                    {
                      staticClass: "bk-drag-inner-container",
                      attrs: {
                        tag: "div",
                        ghostClass: "bk-drag-ghost",
                        delay: 100,
                        chosenClass: "bk-drag-chosen",
                        dragClass: "bk-drag-drag",
                        animation: 0,
                        disabled: _vm.fileList.length <= 1,
                        move: _vm.moveEvent,
                        filter: ".marking-disabled,.marking-op",
                      },
                      model: {
                        value: _vm.fileList,
                        callback: function ($$v) {
                          _vm.fileList = $$v
                        },
                        expression: "fileList",
                      },
                    },
                    [
                      _c(
                        "transition-group",
                        {
                          attrs: {
                            type: "transition",
                            name: "bk-question-drag",
                          },
                        },
                        _vm._l(_vm.upload.sideCount, function (i) {
                          return _c(
                            "div",
                            {
                              key: "image-" + i,
                              staticClass: "upload-image-item",
                              class: {
                                "marking-disabled": i > _vm.fileList.length,
                              },
                            },
                            [
                              i <= _vm.fileList.length
                                ? [
                                    _c("el-image", {
                                      ref: "images",
                                      refInFor: true,
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                      },
                                      attrs: {
                                        src: _vm.fileList[i - 1],
                                        "preview-src-list": _vm.fileList,
                                        fit: "scale-down",
                                      },
                                    }),
                                    _vm.fileList.length > 1
                                      ? _c(
                                          "span",
                                          { staticClass: "marking-drag-desc" },
                                          [_vm._v("拖拽图片调整顺序")]
                                        )
                                      : _vm._e(),
                                    _c("span", {
                                      staticClass: "el-icon-search marking-op",
                                      on: {
                                        click: function ($event) {
                                          return _vm.previewAction(i)
                                        },
                                      },
                                    }),
                                    _c("span", {
                                      staticClass:
                                        "marking-icon-transform marking-op",
                                      on: {
                                        click: function ($event) {
                                          return _vm.transformAction(i)
                                        },
                                      },
                                    }),
                                  ]
                                : _c("span", { staticClass: "marking-desc" }, [
                                    _vm._v(
                                      "答题卡不全，请继续" +
                                        _vm._s(
                                          _vm.uploadType === "scan"
                                            ? "扫描"
                                            : "上传"
                                        ) +
                                        "！"
                                    ),
                                  ]),
                              _c("span", {
                                staticClass: "el-icon-circle-close",
                                on: {
                                  click: function ($event) {
                                    _vm.fileList = []
                                  },
                                },
                              }),
                              _c("p", { staticClass: "marking-item-desc" }, [
                                _vm._v(
                                  "第" +
                                    _vm._s(Math.ceil(i / 2)) +
                                    "张" +
                                    _vm._s((i - 1) % 2 === 0 ? "正" : "反") +
                                    "面"
                                ),
                              ]),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "upload-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-size",
                  staticStyle: { float: "left" },
                  attrs: { type: "primary", plain: "", size: "mini" },
                  on: { click: _vm.clearFiles },
                },
                [_vm._v("清空图片")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-size",
                  staticStyle: { float: "left" },
                  attrs: { type: "primary", plain: "", size: "mini" },
                  on: { click: _vm.continueScan },
                },
                [
                  _vm._v(
                    _vm._s(!_vm.isCanCut ? "继续" : "重新") +
                      _vm._s(_vm.uploadType === "scan" ? "扫描" : "上传")
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-size",
                  staticStyle: { float: "left" },
                  attrs: {
                    type: "primary",
                    size: "mini",
                    disabled: !_vm.isCanCut,
                  },
                  on: {
                    click: function ($event) {
                      _vm.createCard(function (data) {
                        _vm.showCut(data)
                      })
                    },
                  },
                },
                [_vm._v("切题")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-size",
                  staticStyle: { float: "left" },
                  attrs: {
                    type: "primary",
                    plain: "",
                    size: "mini",
                    disabled: !_vm.isCanCut || !!_vm.upload.examIdForTemplate,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createCard()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
          _vm._m(2),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "切题设置",
            visible: _vm.dialog.visible,
            width: "400px",
            top: "calc(50vh - 130px)",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [_c("dialog-body", { attrs: { item: _vm.dialog } })],
        1
      ),
      _c("client-scan", {
        ref: "clientScan",
        staticClass: "marking-scan",
        attrs: { exam: _vm.examDemo, type: "scan-card-template" },
        on: { change: _vm.changeAction },
      }),
      _vm.uploading
        ? _c("div", { staticClass: "uploading-mask" }, [
            _c("div", { staticClass: "uploading-content" }, [
              _c("span", { staticClass: "yj-icon-loading uploading-icon" }),
              _vm._v(" 上传中，请勿操作（" + _vm._s(_vm.uploadedCount)),
              _vm.uploadType === "upload"
                ? _c("span", [_vm._v("/" + _vm._s(_vm.uploadFileCount))])
                : _vm._e(),
              _vm._v("）... "),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-pic" }, [
      _c("span", { staticClass: "span-label" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inner-logo" }, [
      _c("img", {
        attrs: {
          alt: "添加图片",
          src: require("../../assets/images/scan-img.png"),
        },
      }),
      _c("p", [_vm._v("扫描答题卡")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-warning" }, [
      _c("p", [_vm._v("1、请确保顺序正确")]),
      _c("p", [_vm._v("2、如答题卡倒立，可以进行旋转")]),
      _c("p", [_vm._v("3、如扫描异常，可以重新扫描")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }